"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Contact = void 0;
const React = require("react");
const mobx_react_1 = require("mobx-react");
const react_intl_1 = require("react-intl");
const reactstrap_1 = require("reactstrap");
const store_1 = require("@festival/press/store");
const formik_1 = require("formik");
const select_1 = require("@festival/component/form/select");
const Yup = require("yup");
const Base = require("@festival/component/form/line");
class Contact extends React.Component {
    constructor(props) {
        super(props);
        this.mediaTypes = [];
        this.closeSuccessAlert = () => {
            this.setState({
                submited: false
            });
        };
        this.state = {
            submited: false
        };
        for (const mediaType of store_1.MediaTypes) {
            this.mediaTypes.push({
                value: mediaType,
                label: this.props.intl.formatMessage({ id: `press.contact.form.mediaType.${mediaType}` })
            });
        }
    }
    render() {
        const initialValues = {
            gender: 'female',
            lastname: '',
            firstname: '',
            mediaType: 'other',
            mail: '',
            phone: '',
            address: '',
            postcode: '',
            city: '',
            message: ''
        };
        const schema = Yup.object().shape({
            firstname: Yup.string()
                .required('press.error.common.required'),
            lastname: Yup.string()
                .required('press.error.common.required'),
            mediaType: Yup.string()
                .required('press.error.common.required'),
            mail: Yup.string()
                .required('press.error.common.required'),
            phone: Yup.string()
                .required('press.error.common.required'),
            address: Yup.string()
                .required('press.error.common.required'),
            postcode: Yup.string()
                .required('press.error.common.required'),
            city: Yup.string()
                .required('press.error.common.required'),
            message: Yup.string()
                .required('press.error.common.required'),
        });
        const { pressStore } = this.props;
        if (!pressStore) {
            return null;
        }
        if (this.state.submited) {
            return (React.createElement(reactstrap_1.Alert, { color: "success", className: "m-5", toggle: this.closeSuccessAlert },
                React.createElement(react_intl_1.FormattedMessage, { id: "press.form.success" })));
        }
        return (React.createElement("div", { id: "contact-press" },
            React.createElement(formik_1.Formik, { initialValues: initialValues, validationSchema: schema, validateOnBlur: false, onSubmit: (values, actions) => {
                    pressStore.save(values)
                        .then(() => {
                        actions.setSubmitting(false);
                        actions.resetForm();
                        this.setState({
                            submited: true
                        });
                    })
                        .catch((response) => {
                        actions.setSubmitting(false);
                        if (response.data.violations !== undefined && Object.keys(response.data.violations).length > 0) {
                            for (const key of Object.keys(response.data.violations)) {
                                const messages = [];
                                for (const violation of response.data.violations[key]) {
                                    messages.push(violation);
                                }
                                actions.setFieldError(key, messages.join(', '));
                            }
                        }
                    });
                } }, props => {
                return (React.createElement(reactstrap_1.Form, { onSubmit: props.handleSubmit },
                    React.createElement(reactstrap_1.Row, null,
                        React.createElement(reactstrap_1.Col, null,
                            React.createElement(Base.Line, { field: "gender", title: "press.contact.form.gender" },
                                React.createElement("div", null,
                                    React.createElement(reactstrap_1.CustomInput, { type: "radio", id: "gender_female", name: "gender", value: "female", checked: props.values.gender === 'female', onChange: props.handleChange, label: React.createElement(react_intl_1.FormattedMessage, { id: "press.contact.form.gender.female" }), inline: true }),
                                    React.createElement(reactstrap_1.CustomInput, { type: "radio", id: "gender_male", name: "gender", value: "male", checked: props.values.gender === 'male', onChange: props.handleChange, label: React.createElement(react_intl_1.FormattedMessage, { id: "press.contact.form.gender.male" }), inline: true }),
                                    props.errors.gender !== undefined && props.touched.gender && (React.createElement(reactstrap_1.FormFeedback, null,
                                        React.createElement(react_intl_1.FormattedMessage, { id: props.errors.gender })))))),
                        React.createElement(reactstrap_1.Col, null,
                            React.createElement(Base.Line, { field: "firstname", title: "press.contact.form.firstname" },
                                React.createElement(reactstrap_1.Input, { type: "text", id: "firstname", name: "firstname", onChange: props.handleChange, onBlur: props.handleBlur, value: props.values.firstname || '' }),
                                props.errors.firstname !== undefined && props.touched.firstname && (React.createElement(reactstrap_1.FormFeedback, null,
                                    React.createElement(react_intl_1.FormattedMessage, { id: props.errors.firstname }))))),
                        React.createElement(reactstrap_1.Col, null,
                            React.createElement(Base.Line, { field: "lastname", title: "press.contact.form.lastname" },
                                React.createElement(reactstrap_1.Input, { type: "text", id: "lastname", name: "lastname", onChange: props.handleChange, onBlur: props.handleBlur, value: props.values.lastname || '' }),
                                props.errors.lastname !== undefined && props.touched.lastname && (React.createElement(reactstrap_1.FormFeedback, null,
                                    React.createElement(react_intl_1.FormattedMessage, { id: props.errors.lastname })))))),
                    React.createElement(reactstrap_1.Row, null,
                        React.createElement(reactstrap_1.Col, null,
                            React.createElement(Base.Line, { field: "mediaType", title: "press.contact.form.mediaType" },
                                React.createElement(select_1.default, { id: "mediaType", name: "mediaType", className: "react-select", options: this.mediaTypes, value: this.mediaTypes.filter(option => option.value === props.values.mediaType), onChange: (option) => props.setFieldValue('mediaType', option ? option.value : '') }),
                                props.errors.mediaType !== undefined && props.touched.mediaType && (React.createElement(reactstrap_1.FormFeedback, null,
                                    React.createElement(react_intl_1.FormattedMessage, { id: props.errors.mediaType }))))),
                        React.createElement(reactstrap_1.Col, null,
                            React.createElement(Base.Line, { field: "mail", title: "press.contact.form.mail" },
                                React.createElement(reactstrap_1.Input, { type: "text", id: "mail", name: "mail", onChange: props.handleChange, onBlur: props.handleBlur, value: props.values.mail || '' }),
                                props.errors.mail !== undefined && props.touched.mail && (React.createElement(reactstrap_1.FormFeedback, null,
                                    React.createElement(react_intl_1.FormattedMessage, { id: props.errors.mail }))))),
                        React.createElement(reactstrap_1.Col, null,
                            React.createElement(Base.Line, { field: "phone", title: "press.contact.form.phone" },
                                React.createElement(reactstrap_1.Input, { type: "text", id: "phone", name: "phone", onChange: props.handleChange, onBlur: props.handleBlur, value: props.values.phone || '' }),
                                props.errors.phone !== undefined && props.touched.phone && (React.createElement(reactstrap_1.FormFeedback, null,
                                    React.createElement(react_intl_1.FormattedMessage, { id: props.errors.phone })))))),
                    React.createElement(reactstrap_1.Row, null,
                        React.createElement(reactstrap_1.Col, { md: 6 },
                            React.createElement(Base.Line, { field: "address", title: "press.contact.form.address" },
                                React.createElement(reactstrap_1.Input, { type: "text", id: "address", name: "address", onChange: props.handleChange, onBlur: props.handleBlur, value: props.values.address || '' }),
                                props.errors.address !== undefined && props.touched.address && (React.createElement(reactstrap_1.FormFeedback, null,
                                    React.createElement(react_intl_1.FormattedMessage, { id: props.errors.address }))))),
                        React.createElement(reactstrap_1.Col, null,
                            React.createElement(Base.Line, { field: "postcode", title: "press.contact.form.postcode" },
                                React.createElement(reactstrap_1.Input, { type: "text", id: "postcode", name: "postcode", onChange: props.handleChange, onBlur: props.handleBlur, value: props.values.postcode || '' }),
                                props.errors.postcode !== undefined && props.touched.postcode && (React.createElement(reactstrap_1.FormFeedback, null,
                                    React.createElement(react_intl_1.FormattedMessage, { id: props.errors.postcode }))))),
                        React.createElement(reactstrap_1.Col, null,
                            React.createElement(Base.Line, { field: "city", title: "press.contact.form.city" },
                                React.createElement(reactstrap_1.Input, { type: "text", id: "city", name: "city", onChange: props.handleChange, onBlur: props.handleBlur, value: props.values.city || '' }),
                                props.errors.city !== undefined && props.touched.city && (React.createElement(reactstrap_1.FormFeedback, null,
                                    React.createElement(react_intl_1.FormattedMessage, { id: props.errors.city })))))),
                    React.createElement(Base.Line, { field: "message", title: "press.contact.form.message" },
                        React.createElement(reactstrap_1.Input, { type: "textarea", id: "message", name: "message", onChange: props.handleChange, onBlur: props.handleBlur, value: props.values.message || '' }),
                        props.errors.message !== undefined && props.touched.message && (React.createElement(reactstrap_1.FormFeedback, null,
                            React.createElement(react_intl_1.FormattedMessage, { id: props.errors.message })))),
                    React.createElement(reactstrap_1.Button, { type: "submit", color: "primary", className: "text-white", disabled: props.isSubmitting },
                        props.isSubmitting ? (React.createElement("i", { className: "mdi mdi-loading mdi-spin mr-2" })) : (React.createElement("i", { className: "mdi mdi-chevron-right mr-2" })),
                        React.createElement(react_intl_1.FormattedMessage, { id: "press.contact.form.submit" }))));
            })));
    }
}
exports.Contact = Contact;
exports.default = react_intl_1.injectIntl(mobx_react_1.inject('pressStore')(mobx_react_1.observer(Contact)));
